type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';

const API_BASE = import.meta.env.VITE_API_URL ?? '/api';

async function request<T>(path: string, options: RequestInit = {}): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers ?? {}),
    },
    ...options,
  });

  if (!res.ok) {
    let message = res.statusText;
    try {
      const data = await res.json();
      message = data.error ?? message;
    } catch (err) {
      // ignore json parse error
    }
    throw new Error(message);
  }

  if (res.status === 204) {
    // @ts-ignore
    return undefined;
  }

  return (await res.json()) as T;
}

export function apiGet<T>(path: string) {
  return request<T>(path);
}

export function apiMutation<T, P = unknown>(path: string, method: HttpMethod, payload?: P) {
  return request<T>(path, {
    method,
    body: payload ? JSON.stringify(payload) : undefined,
  });
}

export function apiPost<T, P = unknown>(path: string, payload?: P) {
  return apiMutation<T, P>(path, 'POST', payload);
}

export function apiPut<T, P = unknown>(path: string, payload?: P) {
  return apiMutation<T, P>(path, 'PUT', payload);
}

export function apiPatch<T, P = unknown>(path: string, payload?: P) {
  return apiMutation<T, P>(path, 'PATCH', payload);
}

export function apiDelete<T>(path: string) {
  return apiMutation<T, unknown>(path, 'DELETE');
}
